module.exports = __webpack_public_path__ + "files/9971d2707241bb6c19cb1141e3b35d76.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_AMS-Regular.ttf
// module id = 1128
// module chunks = 60